import React from "react";
import "./about-me.css";
import Img from "gatsby-image";
import Hobbies from "./hobbies";

const AboutMe = ({ profileImg, hobbyImgs }) => {
  return (
    <section id="about" className="section">
      <h2 className="text-center">ABOUT ME</h2>
      <div className="section-content">
        <div className="row">
          <div className="col-12 col-sm-10 offset-sm-1 col-md-6 offset-md-0 col-lg-5 offset-lg-1 ">
            <Img
              title="Profile image"
              alt="Large image of Manvir"
              sizes={profileImg.sizes}
              className="img-responsive center-block"
            />
          </div>
          <div className="col-12 col-sm-12 col-md-6">
            <h4>About Me</h4>
            <p>
              I am a professional Italian-English and English-Italian translator and Interpreter.
              I am based in Glasgow (UK).
            </p>
           
      </div>
        </div>
        </div>
    </section>
  );
};

export default AboutMe;



// WEBPACK FOOTER //
// ./src/components/about-me.js